import {Component} from '@angular/core';
/**
 * \@title Radios with ngModel
 */
export class RadioNgModelExample {
  favoriteSeason: string;

  seasons = [
    'Winter',
    'Spring',
    'Summer',
    'Autumn',
  ];
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'radio-ng-model-example',
  templateUrl: 'radio-ng-model-example.html',
  styleUrls: ['radio-ng-model-example.css'],
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function RadioNgModelExample_tsickle_Closure_declarations() {
/** @type {?} */
RadioNgModelExample.decorators;
/**
 * @nocollapse
 * @type {?}
 */
RadioNgModelExample.ctorParameters;
/** @type {?} */
RadioNgModelExample.prototype.favoriteSeason;
/** @type {?} */
RadioNgModelExample.prototype.seasons;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
